<template>
  <div>
    <Component
      :is="stepComponent"
      key="0"
      @setStep="setStep"
    />
    <Component
      :is="iconComponent"
      v-if="iconComponent"
      key="1"
      class="questionnaire__substrate-img"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Register from './page/Register';
import SendCode from './page/SendCode';
import NoTelegram from './page/NoTelegram';
import TelegramHelper from './page/TelegramHelper';

import Hello from '../../../components/iconList/Hello';
import Arms from '../../../components/iconList/Arms';

export default {
  components: {
    Register,
    SendCode,
    NoTelegram,
    TelegramHelper,
    Hello,
    Arms
  },
  data: () => ({
    code: '',
    active: false,
    step: 'Register'
  }),
  computed: {
    ...mapState('questionnaire', {
      history: s => s.data.history
    }),
    stepComponent() {
      // Мало ли шо случится
      switch (this.step) {
      case 'Register':
        return 'Register';
      case 'NoTelegram':
        return 'NoTelegram';
      case 'SendCode':
        return 'SendCode';
      case 'TelegramHelper':
        return 'TelegramHelper';
      default:
        return 'Register';
      }
    },
    iconComponent() {
      switch (this.step) {
      case 'Register':
      case 'SendCode':
        return 'Hello';

      case 'NoTelegram':
      case 'TelegramHelper':
        return 'Arms';

      default:
        return undefined;
      }
    }
  },
  mounted() {
    // При попадании на стриницу тригерим логику бота с бэке
    this.getCode();
  },
  methods: {
    setStep(value) {
      this.step = value;
    },
    async getCode() {
      await this.$store.dispatch('questionnaire/getTelegramCode');
    }
  }
};
</script>
